document.addEventListener('shopify:section:load', function () {
  initAnnouncementArrowRotation();
});

// Debounce function to limit scroll handler calls
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// Function to handle scroll-based arrow rotation
function initAnnouncementArrowRotation() {
  const announcementButtons = document.querySelectorAll('.announcement-bar__button[href^="#MainProduct-"]');
  if (!announcementButtons.length) {
    console.log('Announcement buttons linking to MainProduct not found.');
    return;
  }

  announcementButtons.forEach((button) => {
    const arrowIcon = button.querySelector('.icon-arrow');
    if (arrowIcon) {
      arrowIcon.style.transition = 'transform 0.2s ease-in-out';
    }
  });

  const mainProductSection = document.querySelector('[id^="MainProduct-"]');

  if (!mainProductSection) {
    console.log('MainProduct section not found on this page.');
    announcementButtons.forEach((button) => {
      const arrowIcon = button.querySelector('.icon-arrow');
      if (arrowIcon) {
        arrowIcon.style.transform = 'rotate(270deg)';
      }
      button.classList.remove('is-above-product', 'is-below-product');
    });
    return;
  }

  const checkPosition = () => {
    const productTop = mainProductSection.getBoundingClientRect().top;
    const offset = 20;

    announcementButtons.forEach((button) => {
      const buttonBottom = button.getBoundingClientRect().bottom;
      const arrowIcon = button.querySelector('.icon-arrow');

      if (!arrowIcon) return;

      if (buttonBottom < productTop - offset) {
        arrowIcon.style.transform = 'rotate(90deg)';
        button.classList.add('is-above-product');
        button.classList.remove('is-below-product');
      } else {
        arrowIcon.style.transform = 'rotate(270deg)';
        button.classList.remove('is-above-product');
        button.classList.add('is-below-product');
      }
    });
  };

  const throttledCheckPosition = debounce(checkPosition, 100);
  window.addEventListener('scroll', throttledCheckPosition, { passive: true });
  window.addEventListener('resize', throttledCheckPosition);
  requestAnimationFrame(checkPosition);
}

// Function to handle smooth scrolling for anchor links
function initSmoothScroll() {
  const scrollButtons = document.querySelectorAll('.announcement-bar__button[href^="#"]');

  scrollButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
      const targetId = this.getAttribute('href');
      // Ensure it's a valid ID selector (starts with #) and not just "#"
      if (!targetId || targetId.length <= 1) return;

      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        event.preventDefault(); // Prevent the default jump
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start', // Aligns the top of the target element to the top of the viewport
        });
      } else {
        // Optional: Log if target not found, might indicate an issue
        console.warn(`Smooth scroll target "${targetId}" not found.`);
      }
    });
  });
}

// --- Initialization ---

document.addEventListener('DOMContentLoaded', function () {
  initAnnouncementArrowRotation();
  initSmoothScroll(); // Initialize smooth scroll
});

if (document.readyState !== 'loading') {
  // DOMContentLoaded has already fired
  initAnnouncementArrowRotation();
  initSmoothScroll(); // Initialize smooth scroll
} else {
  // Listener already attached for DOMContentLoaded
}

// Also initialize on Shopify section load for theme editor compatibility
document.addEventListener('shopify:section:load', function () {
  initAnnouncementArrowRotation();
  initSmoothScroll(); // Initialize smooth scroll
});
